import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';

import {fetchUserIdentityData} from '../../dataFetchers/noAuthDataFetcher'
import { Configuration } from "../../configs/Configuration";
import { parseQueryParams } from '../../helpers/URLHelper';
import {setUserHash} from '../../actions/userDataActions';
import { currentAuthToken, setExternalParams } from '../../helpers/authHelper'
import BCLLoading from '../../components/common/Loading/BCLLoading';
import Unauthorized from '../../components/common/Error/Unauthorized/Unauthorized';
import { isAuthenticatedUsingSSO } from '../../actions/ssoActions';
import { bidgelyStorage } from '../../helpers/storageHelper';
import { setUserLocaleFromQueryParam } from '../../helpers/helper';

const namespace = Configuration.getConfiguration().namespace;
const DashboardContainer = React.lazy(() =>  import(`../../components/dashboard${namespace? `-${namespace}`: ''}/DashboardContainer`));


class AuthenticationLayer extends React.Component{
    configuration = Configuration.getConfiguration();

    componentDidMount(){
        let options={
            "pilot-id" : this.configuration.pilotId,
            "client-id" : this.configuration.clientId
        }
        //Set extraParams in authHelper for preview pilot (launchpad).
        if(this.configuration && this.configuration.externalParams){
            let externalParams = this.configuration.externalParams;
            options["external-params"] = externalParams;
            setExternalParams(externalParams);
        }
        if (this.configuration && this.configuration.locale) {
            let locale = this.configuration.locale;
            setUserLocaleFromQueryParam(locale);
        }
        let userHash = null;
        if(this.props.location.search !== ""){
           let parsedString = parseQueryParams(this.props.location.search);
            if (parsedString['user-hash']) {
                userHash = parsedString['user-hash'];
                bidgelyStorage.setItem('userHash', userHash);
                // Remove SSO related keys from local storage if somebody loading user with user-hash
                // it could be a different user
                bidgelyStorage.removeItem('sso');
                bidgelyStorage.removeItem('isCobrowsing');
                bidgelyStorage.removeItem('adminAuthToken');
            }
        }
        userHash = bidgelyStorage.getItem('userHash');
        let adminAuthToken = bidgelyStorage.getItem('adminAuthToken');
        this.props.setUserHash(userHash);
        this.props.fetchUserIdentityData(userHash, options, adminAuthToken);
    }

    render(){
        return(
            <React.Suspense fallback={<BCLLoading />}>
                {this.props.userHash.userHashExpired ?
                    <Unauthorized />
                :
                    ((currentAuthToken !== null) && (this.props.userIdentityDetails !== null) ? <Route component={DashboardContainer}/> : <BCLLoading />)}
            </React.Suspense>
        )
    }
}

const mapStateToProps = state => {
    return{
        userIdentityDetails : state.userIdentityDetails,
        userHash : state.userHash
    }
}

const mapDispatchToProps = dispatch => {
    return{
        setUserHash : (userHash) => dispatch(setUserHash(userHash)),
        fetchUserIdentityData : (userHash, options, adminAuthToken) => dispatch(fetchUserIdentityData(userHash, options, adminAuthToken)),
        isAuthenticatedUsingSSO: () => dispatch(isAuthenticatedUsingSSO())
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(AuthenticationLayer);
